import React from 'react'
import { FormikStepProps } from '../../../components/form/wizzard/FormikStepper'
import { Grid } from '@mui/material'
import InputField from '../../../components/form/InputField'
import UrlRedirectCheck from '../../../components/form/UrlRedirectCheck'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'
import MarketSelectField from '../../../components/form/MarketSelectField'
import IabAutoCompleteField from '../../../components/form/IABAutoCompleteField'
import { GetCompanyDetailsQuery } from '../../../__generated__/graphql'
import { WebsiteCreatePositionsSection } from './WebsiteCreatePositionsSection'

const WebsiteDetailStep: React.FC<
  FormikStepProps & {
    company?: GetCompanyDetailsQuery['company']
  }
> = ({ company }) => {
  const t = useAppTranslations()

  return (
    <Grid
      container
      direction="row"
      spacing={3}
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}
    >
      <Grid container direction="column" size={6}>
        <Grid>
          <InputField name={'name'} label={'commons.name'} type={'text'} fullWidth required variant="outlined" />
        </Grid>
        <Grid>
          <InputField name={'url'} label={'website.details.url'} type={'text'} fullWidth required variant="outlined" />
          <UrlRedirectCheck name="url" />
        </Grid>
      </Grid>
      <Grid container direction="column" size={6}>
        <Grid>
          <IabAutoCompleteField name={'iabCategory'} label={t('commons.iabCategory')} />
        </Grid>
        <Grid>
          <MarketSelectField name={'marketId'} label={t('website.details.market')} required variant="outlined" />
        </Grid>
      </Grid>
      <Grid size={12}>
        <WebsiteCreatePositionsSection company={company} />
      </Grid>
    </Grid>
  )
}

export default WebsiteDetailStep
